import React, { useRef } from 'react';
import styled from 'styled-components';
import color from 'styles/colors';
import { handleTrackEvent, Events } from 'lib/analytics/trackCalls';
import { ROUTE_MVPD } from 'constants/index';
import { Image, Icons } from 'components/common';
import clearButton from 'images/global/clearButton.png';
import { ProviderSearchListElementsText } from '../ProviderSearchList';

export type Props = {
  searchQuery: string;
  setSearchQuery: (s: string) => void;
  setFilteredList: (p: never[]) => void;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setIsFocusedTrue: () => void;
  setIsFocusedFalse: () => void;
  isFocused: boolean;
};

const handleSearchProviderInputClick = () => {
  handleTrackEvent({
    eventName: Events.BUTTON_LINK_SELECTED,
    props: {
      page_item_title: ProviderSearchListElementsText.searchAllProvidersInput,
      page_destination_url: window.location.origin + ROUTE_MVPD,
    },
  });
};

const SearchInput = ({
  setFilteredList,
  searchQuery,
  handleChange,
  setSearchQuery,
  setIsFocusedTrue,
  setIsFocusedFalse,
  isFocused,
}: Props): JSX.Element | null => {
  const searchInput = useRef(null);

  return (
    <>
      <Form>
        <div className="searchWrap">
          <input
            onChange={(e) => {
              handleChange(e);
            }}
            className="search"
            type="text"
            value={searchQuery}
            ref={searchInput}
            onFocus={setIsFocusedTrue}
            onKeyPress={(e) => {
              e.key === 'Enter' && e.preventDefault();
            }}
            onClick={handleSearchProviderInputClick}
          />
          {isFocused && (
            <div className="closeWrap">
              <Image
                width={18}
                height={18}
                className="close"
                onClick={() => {
                  setIsFocusedFalse();
                  setFilteredList([]);
                  setSearchQuery('');
                }}
                src={clearButton}
                alt="Close button"
              />
            </div>
          )}
          {!isFocused && (
            <div className="searchPlaceholder">
              <>
                <div className="searchMag">
                  <Icons.SearchIcon />
                </div>
                <span>{ProviderSearchListElementsText.searchAllProvidersInput}</span>
              </>
            </div>
          )}
        </div>
      </Form>
    </>
  );
};

export default React.memo(SearchInput);

const Form = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 3px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  height: 50px;
  width: calc(100vw - 45px);
  max-width: 330px;
  position: relative;
  margin: 20px auto 0;
  input:focus {
    outline: none;
  }
  .searchWrap {
    display: flex;
    height: inherit;
    justify-content: center;
    align-items: center;
  }

  .search {
    background: 0 0;
    border: none;
    font-family: 'Graphik', sans-serif;
    width: calc(100% - 60px);
    height: 30px;
    margin-right: 40px;
    line-height: 30px;
    letter-spacing: 0;
    font-weight: 400;
    color: ${color.white};
    font-size: 14px;
  }

  .closeWrap {
    position: absolute;
    right: 15px;
    bottom: 10px;
    .close {
      display: none;
      position: absolute;
      height: 18px;
      width: 18px;
      top: 16px;
      right: 16px;
      border: none;
      outline: 0;
      cursor: pointer;
    }
  }

  .searchMag {
    svg {
      opacity: 0.5;
      margin-right: 0.5rem;
      width: 17px;
    }
  }

  .searchPlaceholder {
    width: 100%;
    position: absolute;
    font-family: 'Graphik', sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    pointer-events: none;
    span {
      color: ${color.white};
      font-family: 'Graphik', sans-serif;
      font-size: 14px;
      font-weight: 500;
      height: 30px;
      letter-spacing: 0;
      line-height: 30px;
    }
  }
`;
